import { createContext, useContext, type ReactNode } from 'react';

/**
 * True when CustomerShellHeader left slot is rendering hierarchical / step ←.
 * Content-row CustomerSubpageBackBar / JourneyShell auto bars must suppress
 * to avoid a double chevron for the same parent.
 */
const ShellDepthBackContext = createContext(false);

export function useShellOwnsHierarchicalBack(): boolean {
  return useContext(ShellDepthBackContext);
}

export function ShellDepthBackProvider({
  ownsBack,
  children,
}: {
  readonly ownsBack: boolean;
  readonly children: ReactNode;
}): JSX.Element {
  return (
    <ShellDepthBackContext.Provider value={ownsBack}>
      {children}
    </ShellDepthBackContext.Provider>
  );
}
